import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

// Separado da entidade falsa: o arquivo de rota entra no bundle de produção (routeTree), e importar a
// entidade inteira puxava `shared/patterns`, big.js e date-fns para o JS inicial (+9 KB gz).
export const sampleStatus = z.enum(['Active', 'Paused', 'Closed']);
export type SampleStatus = z.infer<typeof sampleStatus>;

/** URL de /dev/patterns: lista (página, tamanho, ordem, filtros), registro aberto e formulário. */
export const patternsSearch = listSearchSchema({
  q: z.string().max(80).optional().catch(undefined),
  status: sampleStatus.optional().catch(undefined),
  item: z.string().min(1).optional().catch(undefined),
  edit: z.string().min(1).optional().catch(undefined),
});
export type PatternsSearch = z.infer<typeof patternsSearch>;
